module.exports = __webpack_public_path__ + "img/money-bag.aac676fd.svg";